import { Controller, useFormContext } from "@ui/components/Form";
import { useTranslations } from "@ui/providers/useTranslations";

import { useConfig } from "@jti/app-context/useConfig";
import { SupportingText } from "@jti/core-components";
import type { SelectOptionType } from "@jti/fe-common";

import { DateDropdown } from "../DateDropdown";
import { DateInputs } from "../DateInputs/DateInputs";
import { InputLabel } from "../Inputs/components/InputWrapper/InputLabel";

import styles from "./DateOfBirthFormProvider.module.scss";

type DateOfBirthFormProviderProps = {
  fieldsPrefix: string;
  fieldName: string;
  yearsRange?: SelectOptionType[];
  isDateChangeRestricted?: boolean;
  required?: boolean;
};

export const DateOfBirthFormProvider = (props: DateOfBirthFormProviderProps) => {
  const { dobFormType } = useConfig();
  const { __ } = useTranslations();
  const { control } = useFormContext();
  const { required = false } = props;

  return (
    <Controller
      name={props.fieldName}
      control={control}
      rules={{
        ...(required && { required: __("form_validation.field_required") }),
      }}
      render={({ field, fieldState }) => {
        const { ref: _ref, ...fieldWithoutRef } = field;

        return (
          <div className={styles.datesInputWrapper} role="group" aria-labelledby={`${props.fieldName}-label`}>
            <InputLabel id={`${props.fieldName}-label`}>{`${__("auth.registration.dob.title")} *`}</InputLabel>
            {dobFormType === "inputs" || dobFormType === "inputs_reversed" ? (
              <DateInputs {...props} {...fieldWithoutRef} isReversed={dobFormType === "inputs_reversed"} />
            ) : (
              <DateDropdown
                {...props}
                {...fieldWithoutRef}
                dropdownFieldPrefix={props.fieldsPrefix}
                isError={!!fieldState.error}
                required={required}
              />
            )}
            {fieldState?.error?.message && (
              <SupportingText variant="error" data-testid="textInputInfoIcon">
                {fieldState.error.message}
              </SupportingText>
            )}
          </div>
        );
      }}
    />
  );
};
